module.exports = __webpack_public_path__ + "static/img/1.3f1d45c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka1/1.jpg
// module id = E5Ch
// module chunks = 16